<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="logistics"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class LogisticShow extends Vue {
  data = {}

  get columns() {
    return createColumns.call(this, {
      detail: true
    })
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.data = await this.$request.get(`/logistics/${this.$route.params.id}`);
  }
}
</script>
